import brandService from './define-service/brand-service';
import { createUseQuery } from './service-creator';

const rootService = {
  brand: brandService,
};

export const inferQuery = createUseQuery(rootService);
